





















































import { defineComponent } from "@vue/composition-api";
import emitter from "@/lib/emitter";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "NotificationBar",
  components: { BaseSpinner, BaseButton, BaseIcon, BaseAvatar },
  data() {
    return {
      notification: null as NotificationData | null,
      timeoutId: 0 as NodeJS.Timeout | number,
      spinnerKey: 0,
    };
  },
  computed: {
    position(): string {
      return this.notification?.position ?? "bottom";
    },
  },
  methods: {
    setTimeout(period: number) {
      typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(this.clearNotification, period);
    },

    onButtonClick() {
      this.notification?.button?.cb && this.notification?.button?.cb();
      this.clearNotification();
    },

    onNotificationClick() {
      this.notification?.onNotificationClick && this.notification?.onNotificationClick();
      this.clearNotification();
    },

    async addNotification(notification: NotificationData) {
      this.clearNotification();
      await this.$nextTick();
      this.notification = notification;
      this.spinnerKey++;
      this.setTimeout(notification.timeout ?? 4000);
    },

    clearNotification() {
      typeof this.timeoutId === "number" ? clearTimeout(this.timeoutId) : clearTimeout(this.timeoutId);
      this.notification = null;
      this.timeoutId = 0;
    },
  },
  mounted() {
    (window as any).emitter = emitter;
    emitter.on<any>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.on<any>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  },
  beforeDestroy() {
    emitter.off<any>(EVENTS.NOTIFICATION_SHOW, this.addNotification);
    emitter.off<any>(EVENTS.NOTIFICATION_HIDE, this.clearNotification);
  },
});
